import { render, staticRenderFns } from "./AddToCartNotification.vue?vue&type=template&id=70fcaf33&scoped=true&"
import script from "./AddToCartNotification.vue?vue&type=script&lang=ts&"
export * from "./AddToCartNotification.vue?vue&type=script&lang=ts&"
import style0 from "./AddToCartNotification.vue?vue&type=style&index=0&id=70fcaf33&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fcaf33",
  null
  
)

export default component.exports